import { PressEvent } from "react-aria";

import { Cross } from "components/icons/generated";
import Button from "ds/components/Button";

import styles from "./styles.module.css";

type FilterSectionContentActionsProps = {
  selectedSize: number;
  handleResetAll: (e: PressEvent) => void;
};

const FilterSectionContentActions = ({
  selectedSize,
  handleResetAll,
}: FilterSectionContentActionsProps) => {
  return (
    <span className={styles.listActions}>
      {/* // TODO: uncomment when backend optimize "select all" behavior */}
      {/* {!allSelected && (
          <Link className={styles.action} onPress={handleSelectAll}>
            Select all
          </Link>
        )}{" "} */}
      {/* {!allSelected && selectedValues.size > 0 && "or"}{" "} */}
      {selectedSize > 0 && (
        <Button startIcon={Cross} variant="ghost" size="small" onPress={handleResetAll}>
          Clear all
        </Button>
      )}
    </span>
  );
};

export default FilterSectionContentActions;
